import React from 'react';

const Chart = ({
    width = 800,
    height = 500,
    preserveAspectRatio = 'xMidYMid meet',
    children,
    isDynamic = false,
    style,
    className,
    ...props
}) => {
    const svgProps = {
        width: isDynamic ? width : "100%",
        height: isDynamic ? height : "100%",
        style: style || (isDynamic ? {} : { maxWidth: '100%', height: 'auto' }),
        className,
        ...props,
        ...(!isDynamic ? {
            viewBox: `0 0 ${width} ${height}`,
            preserveAspectRatio: preserveAspectRatio
        } : {})
    };

    return (
        <svg {...svgProps}>
            {children}
        </svg>
    );
};

export default Chart;
